import { useQuery } from '@apollo/client/react';
import { GET_INVOICES } from '@/graphql/queries/invoices';
import type { InvoiceData } from '../types';

const INVOICES_PAGE = 12;

type UseGetInvoicesResult = {
  invoices: InvoiceData[];
  isLoading: boolean;
  error: Error | undefined;
  refetch: () => Promise<unknown>;
};

export function useGetInvoices(isSkipped: boolean): UseGetInvoicesResult {
  const { data, previousData, loading, error, refetch } = useQuery(GET_INVOICES, {
    variables: { first: INVOICES_PAGE },
    skip: isSkipped,
    fetchPolicy: 'cache-and-network',
    context: { skipGlobalErrorToast: true },
  });
  const result = data ?? previousData;
  return {
    invoices: result?.viewer?.workspace?.invoices.nodes ?? [],
    isLoading: loading && !result,
    error: result ? undefined : error,
    refetch,
  };
}
